import { ColumnState } from 'ag-grid-community';
import { create } from 'zustand';
import {
    HRM1040_R01EducationDto,
    HRM1040_R01FamilyDto,
    HRM1040_R01HeaderDto,
    defaultHRM1040_R01EducationDto,
    defaultHRM1040_R01FamilyDto,
    defaultHRM1040_R01HeaderDto,
} from './Dto_HRM1040_R01';
import { HRM1040_R01GridType } from './Util_HRM1040_R01';

/** 사원 검색 조건이다. */
export interface HRM1040_R01Filter {
    compCd: string; // 사업장
    orgCd: string; // 부서
    empSts: string; // 재직상태
    keyword: string; // 사원번호 또는 이름
    empNm: string; // 팝업에서 선택한 사원명
}
/** 신규 화면의 사원 검색 기본 조건이다. 재직상태는 재직(10)으로 시작한다. */
export const defaultHRM1040_R01Filter: HRM1040_R01Filter = {
    compCd: '',
    orgCd: '',
    empSts: '10',
    keyword: '',
    empNm: '',
};

/** 가족·학력 화면 상태와 변경 함수이다. */
interface Store_HRM1040_R01 {
    HRM1040_R01Filter: HRM1040_R01Filter; // 현재 입력 중인 검색 조건
    HRM1040_R01PastFilter: HRM1040_R01Filter; // 마지막으로 조회한 검색 조건
    setHRM1040_R01Filter: (value: Partial<HRM1040_R01Filter>) => void; // 검색 조건 일부 변경
    setHRM1040_R01PastFilter: (value: HRM1040_R01Filter) => void; // 마지막 조회 조건 저장
    activeGridType: HRM1040_R01GridType; // 마지막으로 작업한 하위 그리드
    setActiveGridType: (value: HRM1040_R01GridType) => void; // 마지막 작업 그리드 변경
    HRM1040_R01List: HRM1040_R01HeaderDto[]; // 사원 목록
    setHRM1040_R01List: (value: HRM1040_R01HeaderDto[]) => void; // 서버 사원 목록으로 교체
    selectedHRM1040_R01?: HRM1040_R01HeaderDto; // 현재 선택한 사원
    setSelectedHRM1040_R01: (value?: HRM1040_R01HeaderDto) => void; // 선택 사원 변경
    HRM1040_R01FamilyList: HRM1040_R01FamilyDto[]; // 편집 중인 가족 목록
    setHRM1040_R01FamilyList: (value: HRM1040_R01FamilyDto[]) => void; // 서버 가족 목록으로 교체하고 선택·삭제 표시 초기화
    updateHRM1040_R01FamilyList: (valueIndex: number, value: HRM1040_R01FamilyDto) => void; // valueIndex가 같은 가족 행 교체
    insertHRM1040_R01FamilyList: (value: HRM1040_R01FamilyDto, afterValueIndex?: number) => void; // 가족 행 추가
    removeHRM1040_R01FamilyList: (valueIndex: number) => void; // valueIndex가 같은 가족 행 제거
    selectedHRM1040_R01FamilyList: string[]; // 선택한 가족 valueIndex 문자열 목록
    setSelectedHRM1040_R01FamilyList: (value: string[]) => void; // 가족 선택 목록 변경
    deletedHRM1040_R01FamilyList: string[]; // 삭제 표시한 가족 valueIndex 문자열 목록
    setDeletedHRM1040_R01FamilyList: (value: string[]) => void; // 가족 삭제 표시 목록 변경
    originalHRM1040_R01FamilyList: HRM1040_R01FamilyDto[]; // 수정 여부 비교용 서버 가족 목록
    setOriginalHRM1040_R01FamilyList: (value: HRM1040_R01FamilyDto[]) => void; // 비교용 가족 목록 저장
    HRM1040_R01EducationList: HRM1040_R01EducationDto[]; // 편집 중인 학력 목록
    setHRM1040_R01EducationList: (value: HRM1040_R01EducationDto[]) => void; // 서버 학력 목록으로 교체하고 선택·삭제 표시 초기화
    updateHRM1040_R01EducationList: (valueIndex: number, value: HRM1040_R01EducationDto) => void; // valueIndex가 같은 학력 행 교체
    insertHRM1040_R01EducationList: (value: HRM1040_R01EducationDto, afterValueIndex?: number) => void; // 학력 행 추가
    removeHRM1040_R01EducationList: (valueIndex: number) => void; // valueIndex가 같은 학력 행 제거
    selectedHRM1040_R01EducationList: string[]; // 선택한 학력 valueIndex 문자열 목록
    setSelectedHRM1040_R01EducationList: (value: string[]) => void; // 학력 선택 목록 변경
    deletedHRM1040_R01EducationList: string[]; // 삭제 표시한 학력 valueIndex 문자열 목록
    setDeletedHRM1040_R01EducationList: (value: string[]) => void; // 학력 삭제 표시 목록 변경
    originalHRM1040_R01EducationList: HRM1040_R01EducationDto[]; // 수정 여부 비교용 서버 학력 목록
    setOriginalHRM1040_R01EducationList: (value: HRM1040_R01EducationDto[]) => void; // 비교용 학력 목록 저장
    columnState: ColumnState[] | null; // 사원 그리드 컬럼 배치. null이면 기본 배치
    familyColumnState: ColumnState[] | null; // 가족 그리드 컬럼 배치
    educationColumnState: ColumnState[] | null; // 학력 그리드 컬럼 배치
    setColumnState: (value: ColumnState[] | null) => void; // 사원 그리드 컬럼 배치 저장
    setFamilyColumnState: (value: ColumnState[] | null) => void; // 가족 그리드 컬럼 배치 저장
    setEducationColumnState: (value: ColumnState[] | null) => void; // 학력 그리드 컬럼 배치 저장
    scrollTop: number | null; // 사원 그리드 스크롤 위치. null이면 맨 위
    familyScrollTop: number | null; // 가족 그리드 스크롤 위치
    educationScrollTop: number | null; // 학력 그리드 스크롤 위치
    setScrollTop: (value: number | null) => void; // 사원 그리드 스크롤 위치 저장
    setFamilyScrollTop: (value: number | null) => void; // 가족 그리드 스크롤 위치 저장
    setEducationScrollTop: (value: number | null) => void; // 학력 그리드 스크롤 위치 저장
    allCount: number; // 검색 조건에 맞는 전체 사원 수
    setAllCount: (value: number) => void; // 전체 사원 수 저장
    initData: () => void; // 화면 전체 상태 초기화
}

/**
 * 서버 행에 화면 식별값과 기본 필드를 채운다.
 * @param rows 서버에서 받은 행 목록
 * @param defaults 서버 행에 없는 필드를 채울 기본 행
 * @returns 1부터 순서대로 valueIndex·orderIndex를 매긴 행 목록
 */
const buildRows = <T extends { valueIndex: number; orderIndex: number; orderIndexSeq: number }>(
    rows: T[],
    defaults: T,
): T[] => rows.map((row, index) => ({
    ...defaults,
    ...row,
    valueIndex: index + 1,
    orderIndex: index + 1,
    orderIndexSeq: 0,
}));

/** 지정한 행 뒤에 새 행을 삽입하고 중복되지 않는 화면 식별값을 부여한다. */
const insertRow = <T extends { valueIndex: number }>(rows: T[], value: T, afterValueIndex?: number): T[] => {
    const result = [...rows];
    const targetIndex = result.findIndex(row => row.valueIndex === afterValueIndex);
    const insertPosition = afterValueIndex === undefined || targetIndex < 0
        ? result.length
        : targetIndex + 1;
    const nextValueIndex = Math.max(0, ...result.map(row => row.valueIndex)) + 1;

    result.splice(insertPosition, 0, { ...value, valueIndex: nextValueIndex });
    return result;
};

/** 가족·학력 화면 전용 상태를 보관하는 Zustand Hook이다. */
export const useHRM1040_R01Store = create<Store_HRM1040_R01>((set) => ({
    HRM1040_R01Filter: { ...defaultHRM1040_R01Filter },
    HRM1040_R01PastFilter: { ...defaultHRM1040_R01Filter },
    setHRM1040_R01Filter: value => set(state => ({ HRM1040_R01Filter: { ...state.HRM1040_R01Filter, ...value } })),
    setHRM1040_R01PastFilter: value => set({ HRM1040_R01PastFilter: { ...value } }),
    activeGridType: 'family',
    setActiveGridType: value => set({ activeGridType: value }),

    HRM1040_R01List: [],
    setHRM1040_R01List: value => set({ HRM1040_R01List: buildRows(value, defaultHRM1040_R01HeaderDto) }),
    selectedHRM1040_R01: undefined,
    setSelectedHRM1040_R01: value => set({ selectedHRM1040_R01: value }),

    HRM1040_R01FamilyList: [],
    setHRM1040_R01FamilyList: value => set({
        HRM1040_R01FamilyList: buildRows(value, defaultHRM1040_R01FamilyDto),
        selectedHRM1040_R01FamilyList: [],
        deletedHRM1040_R01FamilyList: [],
    }),
    updateHRM1040_R01FamilyList: (valueIndex, value) => set(state => ({
        HRM1040_R01FamilyList: state.HRM1040_R01FamilyList.map(row =>
            row.valueIndex === valueIndex ? value : row),
    })),
    insertHRM1040_R01FamilyList: (value, afterValueIndex) => set(state => ({
        HRM1040_R01FamilyList: insertRow(state.HRM1040_R01FamilyList, value, afterValueIndex),
    })),
    removeHRM1040_R01FamilyList: valueIndex => set(state => ({
        HRM1040_R01FamilyList: state.HRM1040_R01FamilyList.filter(row => row.valueIndex !== valueIndex),
    })),
    selectedHRM1040_R01FamilyList: [],
    setSelectedHRM1040_R01FamilyList: value => set({ selectedHRM1040_R01FamilyList: value.map(String) }),
    deletedHRM1040_R01FamilyList: [],
    setDeletedHRM1040_R01FamilyList: value => set({ deletedHRM1040_R01FamilyList: value.map(String) }),
    originalHRM1040_R01FamilyList: [],
    setOriginalHRM1040_R01FamilyList: value => set({
        originalHRM1040_R01FamilyList: buildRows(value, defaultHRM1040_R01FamilyDto),
    }),

    HRM1040_R01EducationList: [],
    setHRM1040_R01EducationList: value => set({
        HRM1040_R01EducationList: buildRows(value, defaultHRM1040_R01EducationDto),
        selectedHRM1040_R01EducationList: [],
        deletedHRM1040_R01EducationList: [],
    }),
    updateHRM1040_R01EducationList: (valueIndex, value) => set(state => ({
        HRM1040_R01EducationList: state.HRM1040_R01EducationList.map(row =>
            row.valueIndex === valueIndex ? value : row),
    })),
    insertHRM1040_R01EducationList: (value, afterValueIndex) => set(state => ({
        HRM1040_R01EducationList: insertRow(state.HRM1040_R01EducationList, value, afterValueIndex),
    })),
    removeHRM1040_R01EducationList: valueIndex => set(state => ({
        HRM1040_R01EducationList: state.HRM1040_R01EducationList.filter(row => row.valueIndex !== valueIndex),
    })),
    selectedHRM1040_R01EducationList: [],
    setSelectedHRM1040_R01EducationList: value => set({ selectedHRM1040_R01EducationList: value.map(String) }),
    deletedHRM1040_R01EducationList: [],
    setDeletedHRM1040_R01EducationList: value => set({ deletedHRM1040_R01EducationList: value.map(String) }),
    originalHRM1040_R01EducationList: [],
    setOriginalHRM1040_R01EducationList: value => set({
        originalHRM1040_R01EducationList: buildRows(value, defaultHRM1040_R01EducationDto),
    }),

    columnState: null,
    familyColumnState: null,
    educationColumnState: null,
    setColumnState: value => set({ columnState: value }),
    setFamilyColumnState: value => set({ familyColumnState: value }),
    setEducationColumnState: value => set({ educationColumnState: value }),
    scrollTop: null,
    familyScrollTop: null,
    educationScrollTop: null,
    setScrollTop: value => set({ scrollTop: value }),
    setFamilyScrollTop: value => set({ familyScrollTop: value }),
    setEducationScrollTop: value => set({ educationScrollTop: value }),
    allCount: 0,
    setAllCount: value => set({ allCount: value }),

    initData: () => set({
        HRM1040_R01Filter: { ...defaultHRM1040_R01Filter },
        HRM1040_R01PastFilter: { ...defaultHRM1040_R01Filter },
        activeGridType: 'family',
        HRM1040_R01List: [],
        selectedHRM1040_R01: undefined,
        HRM1040_R01FamilyList: [],
        selectedHRM1040_R01FamilyList: [],
        deletedHRM1040_R01FamilyList: [],
        originalHRM1040_R01FamilyList: [],
        HRM1040_R01EducationList: [],
        selectedHRM1040_R01EducationList: [],
        deletedHRM1040_R01EducationList: [],
        originalHRM1040_R01EducationList: [],
        columnState: null,
        familyColumnState: null,
        educationColumnState: null,
        scrollTop: null,
        familyScrollTop: null,
        educationScrollTop: null,
        allCount: 0,
    }),
}));
